export enum CardProduct {
  GOLD = 'GOLD',
  CLASSIC = 'CLASSIC',
  EXCLUSIVE = 'EXCLUSIVE',
  EXCLUSIVE_PLUS = 'EXCLUSIVE_PLUS',
}

export type CardInformation = {
  cardLimit: number;
  cardPrice: CardPrice;
  cardType: CardType;
  cardProduct: CardProduct;
};

export type CardPrice = AnnualCardPrice | MonthlyCardPrice | DynamicAnnualCardPrice;

type BasicCardPrice = {
  amount: number;
  note?: string;
  type: string;
};

export type MonthlyCardPrice = {
  type: 'MONTHLY';
} & BasicCardPrice;

export type DynamicAnnualCardPrice = {
  type: 'DYNAMIC_ANNUAL';
  amountSubsequentYears: string;
} & BasicCardPrice;

export type AnnualCardPrice = {
  type: 'ANNUAL';
} & BasicCardPrice;

export enum CardType {
  VisaCard = 'VisaCard',
  MasterCard = 'MasterCard',
}

export function isDynamicAnnualCardPrice(cardPrice: CardPrice): cardPrice is DynamicAnnualCardPrice {
  return cardPrice.type === 'DYNAMIC_ANNUAL';
}

export function isMonthlyCardPrice(cardPrice: CardPrice): cardPrice is MonthlyCardPrice {
  return cardPrice.type === 'MONTHLY';
}

export type CardPriceFootnote = {
  marker: number;
  kind: 'DYNAMIC_ANNUAL' | 'NOTE';
  text: string;
};

export function cardPriceFootnotes(cardPrice: CardPrice): CardPriceFootnote[] {
  const texts: Omit<CardPriceFootnote, 'marker'>[] = [];
  if (isDynamicAnnualCardPrice(cardPrice)) {
    texts.push({
      kind: 'DYNAMIC_ANNUAL',
      text: `Ab dem zweiten Jahr beträgt der Preis der Kreditkarte ${cardPrice.amountSubsequentYears} €.`,
    });
  }
  if (cardPrice.note) {
    texts.push({ kind: 'NOTE', text: cardPrice.note });
  }
  return texts.map((footnote, index) => ({ marker: index + 1, ...footnote }));
}
